import { render, staticRenderFns } from "./PersonalLeaveApplicationTable.vue?vue&type=template&id=5470f5dc&scoped=true&"
import script from "./PersonalLeaveApplicationTable.vue?vue&type=script&lang=js&"
export * from "./PersonalLeaveApplicationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470f5dc",
  null
  
)

export default component.exports